import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'normalizeString'
})
export class NormalizeStringPipe implements PipeTransform {
    transform (value: string): string {
        if (!value) return '';

        return value.trim().toLowerCase().replace(/[\s/]+/g, '_').replace(/[^a-z0-9_]/g, '').replace(/_+/g, '_');
    }
}